export default __webpack_public_path__ + "static/media/manholeCover-show1.3578f589.png";